import React from "react";
import { Container } from "@mui/material";
import PageTitle from "../../components/common/PageTitle";
import ProductManagementGroupsTab from "../../components/product-management-groups/ProductManagementGroupsTab";

const ProductManagementGroupHubPage: React.FC = () => (
  <Container maxWidth="lg" sx={{ py: 3 }}>
    <PageTitle
      pageTitle="Product Management Groups"
      pageDescription="Create groups, manage owners and members, and control who can modify assigned catalog assets."
    />
    <ProductManagementGroupsTab />
  </Container>
);

export default ProductManagementGroupHubPage;
